export default __webpack_public_path__ + "static/media/nervina-wx-official-account-qrcode.1203795f.jpg";